import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const JobCard = ({ job, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);

  const today = new Date();
  const closingDate = new Date(job.closingDate);
  const timeDiff = closingDate - today;
  const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  let statusLabel = '';
  let backgroundColor = '';

  if (daysRemaining < 0) {
    statusLabel = 'Expired';
    backgroundColor = '#d32f2f'; // Red
  } else if (daysRemaining <= 3) {
    statusLabel = `${daysRemaining} day${daysRemaining === 1 ? '' : 's'} left`;
    backgroundColor = '#fbc02d'; // Yellow
  } else {
    statusLabel = `${daysRemaining} days left`;
    backgroundColor = '#388e3c'; // Green
  }

  const handleCardClick = () => {
    if (!isDeleting) {
      navigate(`/job/${job.id}`);
    }
  };

  const handleDeleteClick = async (e) => {
    e.stopPropagation();
    setIsDeleting(true);
    try {
      await onDelete(job.id); // Must return a Promise
    } catch (error) {
      console.error('Delete failed:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div style={styles.card} onClick={handleCardClick}>
      <div style={styles.header}>
        <h3>{job.title}</h3>
        <span style={{ ...styles.status, backgroundColor }}>{statusLabel}</span>
      </div>
      <p><strong>Company:</strong> {job.companyName}</p>
      <p><strong>Location:</strong> {job.location}</p>

      <div style={styles.actions}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit(job.id);
          }}
          style={styles.edit}
        >
          Edit
        </button>

        <button
          onClick={handleDeleteClick}
          style={{
            ...styles.delete,
            opacity: isDeleting ? 0.6 : 1,
            cursor: isDeleting ? 'not-allowed' : 'pointer',
          }}
          disabled={isDeleting}
        >
          {isDeleting ? <div style={styles.spinner} /> : 'Delete'}
        </button>
      </div>
    </div>
  );
};

const styles = {
  card: {
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '12px',
    cursor: 'pointer',
    transition: 'box-shadow 0.2s ease',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  status: {
    color: '#fff',
    padding: '4px 10px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 'bold',
    minWidth: '80px',
    textAlign: 'center',
  },
  actions: {
    marginTop: '10px',
    display: 'flex',
    gap: '10px',
  },
  edit: {
    backgroundColor: '#00796b',
    color: '#fff',
    padding: '6px 10px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  delete: {
    backgroundColor: '#d32f2f',
    color: '#fff',
    padding: '6px 10px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    minWidth: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinner: {
    width: '16px',
    height: '16px',
    border: '2px solid #fff',
    borderTop: '2px solid transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
};

export default JobCard;
